module.exports = __webpack_public_path__ + "static/sample-flyer-25e0a49ad54fe5281bb7dfbcba90851b.webp";